/*
================================================
Une mixin pour gérer le tracking google analytics avec gtag
https://fr.vuejs.org/v2/guide/mixins.html
================================================
*/

//@todo supprimier cette mixin
var  GoogleAnalyticsMixin = {
    created(){
        this.hello()
    },

    data: function () {
        return {
            name: 'GoogleAnalyticsMixin',
        }
    },
    methods: {
        hello: function () {
        },


        /*
            Permet de tracker un évènement dans goole analytics
            https://developers.google.com/analytics/devguides/collection/gtagjs/events

            @action (string) The value that will appear as the event action in Google Analytics Event reports.
            @category (string) The category of the event.
            @label (string) The label of the event.
            @action (number) 	A non-negative integer that will appear as the vent value
         */
        trackEvent: function (action, category, label, value = null){

            this.$gtag.set({'appVersion': process.env.VUE_APP_VERSION})
            this.$gtag.set({'appName': 'pwa'})

            this.$gtag.event(action, category, label, value)

        }

    },

}

export default GoogleAnalyticsMixin;

